<template>
    <div class="preview-wrap" v-if="imgs.length">
        <div class="goodsImgBox">
            <pic-zoom
                :previewImg="img1 || imgs[imgIndex].goods_img"
                :zoomImg="img1 || imgs[imgIndex].goods_img"
            />
            <!-- <img :src="img1 || imgs[imgIndex].goods_img" preview="0" alt class="goodsImgBox" /> -->
        </div>
        <div class="imgItemBox clearfix">
            <i class="el-icon-arrow-left leftBtn" @click="leftClick"></i>
            <i class="el-icon-arrow-right rightBtn" @click="rightClick"></i>
            <div class="spec-item">
                <div class="clearfix indicatorBox fr" ref="indicatorBox" :style="indicatorBoxCss">
                    <div
                        class="indicatorImg mr5"
                        @mouseover="imgMouseover(item.goods_img,index)"
                        :class="{bor: index == imgIndex}"
                        v-for="(item, index) in imgs"
                        :key="index"
                    >
                        <img :src="item.goods_img" class="img" alt />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PicZoom from "@/components/PicZoom";
export default {
    props: {
        imgs: {
            type: [Array, Object],
            default: function() {
                return { message: [] };
            }
        },
        img: String
    },
    computed: {
        indicatorBoxCss() {
            return {
                width: this.imglength.length * 78 + "px",
                left: this.left + "px",
                transition: "left 2s"
            };
        }
    },
    data() {
        return {
            imgIndex: 0,
            pages: 1, // 总页数
            currentPages: 1, // 当前页数
            left: 0, // 左边距
            remain: "", // 模值
            imglength: 0,
            img1: this.img
        };
    },
    methods: {
        // 左移
        leftClick() {
            if (this.pages == 1) {
                return false;
            } else if (this.pages == 2) {
                // 如果只有2页
                this.left = 0;
            } else if (this.pages > 2 && this.currentPages != 1) {
                // 如果是超过2页, 并且当前不是在第一页
                if (this.currentPages == 2) {
                    this.left = 0;
                } else {
                    this.left = this.left + 78 * 5;
                }
                this.currentPages--;
                return false;
            }
        },
        // 右移
        rightClick() {
            if (this.pages == 1) {
                return false;
            } else if (this.pages == 2) {
                this.left = -(78 * this.remain);
            } else if (this.pages > 2 && this.currentPages < this.pages) {
                this.currentPages++;
                if (this.currentPages == this.pages) {
                    this.left = this.left - 78 * this.remain;
                } else {
                    this.left = -(78 * 5 * (this.currentPages - 1));
                }
                return false;
            }
        },
        // 图片hover
        imgMouseover(img, index) {
            this.img1 = "";
            this.currentImg = img;
            this.imgIndex = index;
        }
    },
    mounted() {
        this.$previewRefresh();
    },
    watch: {
        imgs() {
            this.pages = Math.ceil(this.imgs.length / 5);
            this.remain = this.imgs.length % 5;
            this.imglength = this.imgs.length;
        },
        img(n) {
            this.img1 = n;
        }
    },
    components: { PicZoom }
};
</script>

<style scoped>
.preview-wrap {
    width: 100%;
}
.mr5 {
    margin-right: 5px;
}
.goodsImgBox {
    width: 390px;
    height: 390px;
    margin: 0 auto;
    margin-bottom: 20px;
}
.imgItemBox {
    position: relative;
    /* margin-bottom: 20px; */
}
.leftBtn {
    display: block;
    position: absolute;
    cursor: pointer;
    font-size: 24px;
    top: 50%;
    left: 0;
    margin-top: -18px;
}
.rightBtn {
    display: block;
    font-size: 24px;
    position: absolute;
    cursor: pointer;
    top: 50%;
    right: 0;
    margin-top: -18px;
}
.spec-item {
    width: 360px;
    height: 55px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
}
.indicatorBox {
    position: absolute;
    height: 55px;
    width: 100%;
}
.indicatorImg {
    width: 55px;
    height: 55px;
    background-size: 100%;
    position: relative;
}
.bor {
    border: 1px solid red;
}
.indicatorImg .img {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 53px;
    height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/goodsDetails/PreView.vue